<template>
  <v-layout column>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.newPassword"
        :validator="vs.form.newPassword"
        :error-messages="{
          minLength: (isAdminLocalization ? adminText('adminAll.password_must_contain_5_characters_at_least_f7c1c7', 'Password must contain 5 characters at least') : $t(
            'passwordLengthErrorMessage',
            'Password must contain 5 characters at least',
          )),
        }"
        type="password"
        :label="(isAdminLocalization ? adminText('adminAll.new_password_d850ee', 'New password') : $t('newPassword', 'New password'))"
        autofocus
      />
    </v-flex>
    <v-flex class="pb-16">
      <text-field
        :admin-context="isAdminLocalization"
        v-model.trim="form.repeatPassword"
        :validator="vs.form.repeatPassword"
        :error-messages="{ sameAs: (isAdminLocalization ? adminText('adminAll.passwords_don_t_match_5f0879', 'Passwords don\'t match') : $t('passwordsDoNotMatchError', 'Passwords don\'t match')) }"
        type="password"
        :label="(isAdminLocalization ? adminText('adminAll.repeat_password_366c24', 'Repeat password') : $t('repeatPassword', 'Repeat password'))"
      />
    </v-flex>
  </v-layout>
</template>
<script>
import AdminAllMessages from '@/components/admin/AdminAllMessages'
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext, AdminAllMessages],
  name: 'recover-password-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped></style>
